import { useAuthStore } from '@/modules/auth/store/auth';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { hasLoggedInUser, isVerified } = useAuthStore();

  if (hasLoggedInUser && isVerified) {
    return navigateTo('/onboarding');
  }
});
